import { inject, Injectable, isDevMode } from '@angular/core';
import { DOCUMENT } from '@angular/common';

const LINK_TO_CHATBOT_CLASS_NAME_PREFIX = 'CHATBOT_';

@Injectable({
  providedIn: 'root',
})
export class ConversationalChatBindWebsiteLinksService {
  readonly #document = inject(DOCUMENT);
  readonly #logPrefix = 'Cognigy Chatbot Service - ';

  bindLinksToWebchat(
    initWebchat: (invokedClass?: string, webchatDelay?: number) => void
  ) {
    if (isDevMode()) {
      console.info(this.#logPrefix + 'Bind links on webpage to webchat');
    }
    this.#document.body.addEventListener(
      'click',
      (event: Event) => {
        const linkToChatbotClassName = this.#getLinkToChatbotClassName(
          event.target as HTMLElement
        );
        if (linkToChatbotClassName) {
          // chats initiated via a button click may be opened immediately, webchatDelay is 0
          initWebchat(linkToChatbotClassName, 0);
        }
      },
      true
    );
  }

  #getLinkToChatbotClassName(element: HTMLElement): string | undefined {
    return Array.from(element.classList)
      .find((cls) =>
        cls.toUpperCase().startsWith(LINK_TO_CHATBOT_CLASS_NAME_PREFIX)
      )
      ?.toUpperCase();
  }
}
